<template>
    <div class="text-left" :title="getText()">
        <v-select
            v-model="selectedItems"
            :items="items"
            :label="getLabel"
            multiple
            dense
            outlined
            @blur="blurred"
            @focus="focused"
            class="required"
            @change="sendSelectedItems"
        >
            <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">
                    <span>{{ getText() }}</span>
                </span>
            </template>
            <template v-slot:prepend-item v-if="items && items.length">
                <v-list class="drop-down-list">
                    <v-list-item>
                        <v-list-item-title>
                            <div class="check-opction-css check-cust">
                                <v-checkbox
                                    id="all"
                                    @change="changeAll"
                                    v-model="selectAll"
                                    hide-details
                                ></v-checkbox>
                                <span
                                    @click.stop="clickAllText"
                                    class="multi-text"
                                >{{allText > "" ? allText : "All"}}</span>
                            </div>
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </template>
        </v-select>
    </div>
</template>

<script>
export default {
    name: "MultiSelect",
    props: [
        "items",
        "label",
        "onChange",
        "info",
        "widthcss",
        "menuValue",
        "persistentStatus",
        "selectedItemsList",
        "allText"
    ],
    mounted() {
        this.selectAll = this.isAllSelected;
    },
    data() {
        return {
            selectAll: false,
            selectedItems: []
        };
    },
    methods: {
        getText() {
            if(this.selectedItems.length == this.items.length) {
                return this.allText;
            } else if(this.selectedItems.length < this.items.length) {
                let text = [];
                let selectedItems = this.selectedItems.map(item => item.subject_id) 
                this.items.map(item => {
                    if(selectedItems.includes(item.value.subject_id)){
                        text.push(item.text)
                    }
                })
                return text.join(', ')
            }
        },
        focused() {
            this.persistentStatus(true);
        },
        blurred(e) {
            _.debounce(this.persistentStatus, 200)(false, this);
        },
        changeAll() {
            if (this.selectAll) {
                this.selectedItems = this.items.map(item => item.value);
            } else {
                this.selectedItems = [];
            }
            this.sendSelectedItems();
        },

        clickAllText() {
            this.selectAll = !this.selectAll;
            this.changeAll();
        },

        sendSelectedItems() {
            this.selectAll = this.isAllSelected;
            let tmpArr = [];
            this.selectedItems.map(x => {
                tmpArr.push(x);
            });
            this.onChange(tmpArr, { info: this.info });
        }
    },
    computed: {
        isAllSelected() {
            if (this.selectedItems.length == this.items.length) {
                return true;
            }
            return false;
        },
        getLabel() {
            if (this.selectAll) {
                return this.label;
            }
            let tmpArry = this.selectedItems
                .filter(x => x.checked)
                .map(xx => xx.text);
            if (tmpArry && tmpArry.length) {
                return tmpArry.join();
            }
            return this.label;
        }
    },
    watch: {
        items(val) {
            this.selectAll = this.isAllSelected;

            if (!this.selectedItemsList) {
                this.selectedItems = [];
            }
        },
        selectedItemsList(val) {
            this.selectedItems = val;
            this.selectAll = this.isAllSelected;
        }
    }
};
</script>